// extracted by mini-css-extract-plugin
module.exports = {"noMultiClassStepBtns":"StatisticClasses_noMultiClassStepBtns__3VKmY","btnInactive":"StatisticClasses_btnInactive__1gpoS"};